import styled from "styled-components";
import { theme } from "theme";

export const CodeWrapper = styled.div`
  border: 1px solid ${theme.color.borderLight};
  border-radius: ${theme.borderRadius.base};
  overflow: hidden;
`;
